export var PROMPT_TEMPLATE_REPOSITORY = 'PROMPT_TEMPLATE_REPOSITORY';
export var PromptTemplateCreatedByType;

(function (PromptTemplateCreatedByType) {
  PromptTemplateCreatedByType["Admin"] = "admin";
  PromptTemplateCreatedByType["User"] = "user";
})(PromptTemplateCreatedByType || (PromptTemplateCreatedByType = {}));